export const images = [
    "/images/blue_spaceship.svg",
    "/images/mint_spaceship.svg",
    "/images/pink_spaceship.svg",
    "/images/spaceship.svg",
    "/images/jellyfish.svg",
    "/images/nimo.svg",
    "/images/tuttle.svg",
    "/images/light_blue.svg",
    "/images/light_green.svg",
    "/images/light_orange.svg",
    "/images/light_red.svg",
    "/images/light_yellow.svg",
    "/images/light-black.svg",
    "/images/man.svg",
    "/images/woman.svg"
]